// Shared by every mlComponent page (ML, PyTorch, TensorFlow, Scikit, SciPy,
// LLM): given the full slug list and the entry for the current slug, returns
// the sibling pages that share the same `path` (used to render the "In this
// section" sidebar list). Returns [] when the current entry has no `path`,
// e.g. the not-found fallback entry.
export function getTopicPages(slugs, current, slug) {
    if (!current.path) return [];
    return slugs
        .filter(item => item.path === current.path && item.slug !== slug)
        .map(item => ({title: item.title, slug: item.slug, path: item.path}));
}
